import {faFileInvoice, faPencil} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ActionIcon, Tooltip} from '@mantine/core';
import {FC, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {buildPath} from '../../routes/utils';

type RenderEditButton = {
  item: {id: number};
  route: string;
  descriptor: string;
};

type RenderViewButton = {
  item: {id: number};
  route: string;
  descriptor: string;
};

export const EditButton: FC<RenderEditButton> = (props) => {
  const {item, route, descriptor} = props;
  const url = buildPath(route, {
    id: item.id,
  });

  const navigate = useNavigate();

  const navigateUrl = useCallback(() => {
    navigate(url);
  }, [navigate, url]);

  return (
    <Tooltip label={`Edit ${descriptor}`}>
      <ActionIcon
        className="clear"
        onClick={navigateUrl}
        aria-label={`Edit ${descriptor}`}
      >
        <FontAwesomeIcon icon={faPencil} />
      </ActionIcon>
    </Tooltip>
  );
};

export const ViewButton: FC<RenderViewButton> = (props) => {
  const {item, route, descriptor} = props;
  const url = buildPath(route, {
    id: item.id,
  });

  const navigate = useNavigate();

  const navigateUrl = useCallback(() => {
    navigate(url);
  }, [navigate, url]);

  return (
    <Tooltip label={`View ${descriptor}`}>
      <ActionIcon
        className="clear"
        onClick={navigateUrl}
        aria-label={`View ${descriptor}`}
      >
        <FontAwesomeIcon icon={faFileInvoice} />
      </ActionIcon>
    </Tooltip>
  );
};